var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "title": "Devolução de itens",
      "size": "xl",
      "centered": ""
    },
    on: {
      "hidden": _vm.onHidden
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": _vm.salvarBloqueado
          },
          on: {
            "click": _vm.salvar
          }
        }, [_vm._v(" " + _vm._s(_vm.gerarCredito ? "Gerar crédito/voucher" : "Registrar devolução") + " ")])];
      }
    }])
  }, [_c('div', [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "font-weight-bolder text-dark-75"
  }, [_vm._v(" " + _vm._s(_vm.nomeCliente || "Cliente não informado") + " ")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" Documento " + _vm._s(_vm.documentoVenda) + " - R$ " + _vm._s(_vm.numberToReal(_vm.valorVenda, 2)) + " ")])]), _vm.isLoading ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "info"
    }
  }, [_vm._v(" Carregando itens da venda... ")]) : _vm._e(), _vm.erro ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.carregarDados
    }
  }, [_vm._v(" Tentar novamente ")])], 1)]) : _vm._e(), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "font-weight-bolder text-primary",
    attrs: {
      "switch": "",
      "disabled": !_vm.permiteCreditoVoucher
    },
    model: {
      value: _vm.gerarCredito,
      callback: function callback($$v) {
        _vm.gerarCredito = $$v;
      },
      expression: "gerarCredito"
    }
  }, [_vm._v(" Gerar crédito/voucher ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Desmarcado gera saída no caixa como devolução de produto. ")])], 1), _vm.gerarCredito ? _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "cliente-devolucao"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "cliente-devolucao",
      "filterable": false,
      "options": _vm.clientes
    },
    on: {
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('span', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(_vm._s(option.nome))])];
      }
    }], null, false, 214073843),
    model: {
      value: _vm.cliente,
      callback: function callback($$v) {
        _vm.cliente = $$v;
      },
      expression: "cliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2)], 1)], 1) : _vm._e()], 1), _vm.gerarCredito && !_vm.clienteId ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Selecione o cliente para gerar crédito/voucher. ")]) : _vm._e(), !_vm.permiteCreditoVoucher ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Voucher disponível apenas para vendas recebidas em Dinheiro, PIX, Cartão de Débito ou Cartão de Crédito. ")]) : _vm._e(), _c('b-table', {
    attrs: {
      "items": _vm.itens,
      "fields": _vm.fields,
      "small": "",
      "responsive": "",
      "bordered": "",
      "show-empty": "",
      "empty-text": "Nenhum item encontrado para devolução."
    },
    scopedSlots: _vm._u([{
      key: "cell(quantidade_devolver)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('div', [_c('b-form-input', {
          class: {
            'bg-light text-muted border-secondary': _vm.isItemDevolvido(item)
          },
          attrs: {
            "type": "number",
            "min": "0.0001",
            "max": item.quantidade_disponivel,
            "step": "0.0001",
            "size": "sm",
            "disabled": _vm.isItemDevolvido(item),
            "state": _vm.getQuantidadeState(item)
          },
          on: {
            "change": function change($event) {
              return _vm.validarQuantidadeDevolver(item);
            }
          },
          model: {
            value: item.quantidade_devolver,
            callback: function callback($$v) {
              _vm.$set(item, "quantidade_devolver", _vm._n($$v));
            },
            expression: "item.quantidade_devolver"
          }
        }), _vm.getQuantidadeState(item) === false ? _c('small', {
          staticClass: "text-danger font-weight-bolder"
        }, [_vm._v(" Máximo para devolução: " + _vm._s(_vm.formatarQuantidade(item.quantidade_disponivel)) + " ")]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(valor_total)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.getValorItem(item), 2)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.isItemDevolvido(item) ? _c('span', {
          staticClass: "devolvido-badge"
        }, [_c('span', {
          staticClass: "devolvido-dot"
        }), _vm._v(" Devolvido ")]) : _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Remover da devolução',
            expression: "'Remover da devolução'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon",
          on: {
            "click": function click($event) {
              return _vm.removerItem(item);
            }
          }
        }, [_c('DeleteIcon', {
          attrs: {
            "size": 16
          }
        })], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('div', {
    staticClass: "font-weight-bolder text-primary"
  }, [_vm._v(" Total da devolução: R$ " + _vm._s(_vm.numberToReal(_vm.valorTotal, 2)) + " ")])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };